import React, { Component } from "react";
import { find, filter, findIndex } from "lodash";
import Swiper from "react-id-swiper";
import {
  RODEO_ID,
  CHARM_ID,
  EARRINGS_TYPE_ID,
  MAX_WIDTH_SP
} from "../../const";
import StoneItem from "../Stone/StoneItem";
import StoneByMonthList from "../Stone/StoneByMonthList";

export default class ModalCategoryList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categoryList: [],
      idActive: 0,
      isLoading: false,
      activeLog: []
    };
  }

  componentDidMount() {
    this.setState({
      categoryList: this.props.categoryList,
      idActive: this.props.idCategoryActive,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.categoryList !== this.props.categoryList) {
      this.setState({ categoryList: this.props.categoryList });
    }
  }

  handleChangeTab(index) {
    let { activeLog } = this.state;

    this.setState({ idActive: index });
    //Check active log
    let indexLog = findIndex(activeLog, item => item === index);

    if (indexLog === -1) {
      this.setState({
        activeLog: [...activeLog, index],
        isLoading: true
      });

      setTimeout(() => {
        this.setState({ isLoading: false });
      }, 200);
    }
  }

  handleGetHeight() {
    let heightWin = window.innerHeight;

    return heightWin - 343;
  }

  render() {
    let { categoryList, idActive, isLoading } = this.state;
    let {
      productList,
      handleUpdateState,
      ringIdActive,
      getWidthBrowser
    } = this.props;
    let stoneList = [];
    let productIds = [];
    let filterList = [];
    let params = {
      loadMinimal: true,
      loadMinimalSize: 0,
      slidesPerView: "auto",
      loop: false,
      key: categoryList.length
    };
    let tmp = [...categoryList];

    if (categoryList.length > 0) {
      productIds = categoryList[idActive].product_ids;

      productIds.map(data => {
        let item = find(productList, function(prod) {
          return prod.id === data.id;
        });
        if (item !== undefined) {
          filterList.push(item);
        }
      });
    }

    if (idActive === 1) {
      // active filter by month (idActive = 1)
      let months = [];

      if (categoryList.length > 0) {
        months = categoryList[idActive].product_ids;
      }

      stoneList = months.map((item, index) => {
        return (
          <StoneByMonthList
            month={item}
            productList={productList}
            handleUpdateState={handleUpdateState}
            key={index}
          />
        );
      });
    } else {
      stoneList = filterList.map((item, index) => {
        return (
          <StoneItem
            key={index}
            stone={item}
            handleUpdateState={handleUpdateState}
            productList={productList}
          />
        );
      });
    }

    if (ringIdActive === EARRINGS_TYPE_ID) {
      tmp = filter(
        categoryList,
        item => item.id !== RODEO_ID && item.id !== CHARM_ID
      );
    }

    return (
      <div
        className={`tab_content ${
          getWidthBrowser() < MAX_WIDTH_SP ? "modal_sp" : ""
        }`}
      >
        <div
          className={`sub_tab ${
            getWidthBrowser() < MAX_WIDTH_SP ? "" : "center_mode"
          }`}
        >
          <Swiper {...params}>
            {tmp.map((item, index) => {
              return (
                <div
                  className="sub_tab_item"
                  onClick={() => this.handleChangeTab(index)}
                  key={index}
                >
                  <button className={`${index === idActive ? "active" : ""}`}>
                    {item.name}
                  </button>
                </div>
              );
            })}
          </Swiper>
        </div>
        <div className="material_list_wrap scroll_bar_style">
          {!isLoading ? <ul className="material_list">{stoneList}</ul> : null}
          {isLoading ? (
            <div className="loading">
              <img src="/img/icon-loading-v2.gif" alt="" />
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}
